import { render, staticRenderFns } from "./TiptapOneLine.vue?vue&type=template&id=06d89a42&"
import script from "./TiptapOneLine.vue?vue&type=script&lang=js&"
export * from "./TiptapOneLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports